import { neutral7 } from '../../colors';
import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    color: neutral7,
    marginBottom: 0,
    fontSize: idsTokens.typography.font.size.base,
    fontWeight: idsTokens.typography.font.weight.regular,
    lineHeight: idsTokens.typography.lineHeight.base,
    letterSpacing: idsTokens.typography.spacing.letter.lg,
  },
});
